import { DataTableColumnHeader } from "@/shared/components/table";
import { Checkbox } from "@/shared/components/ui/checkbox";
import type { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import type { AnomalyDetectionRule } from "../types/preferences_types";

export function useAnomalyDetectionColumns() {
    return useMemo<ColumnDef<AnomalyDetectionRule>[]>(
        () => [
            {
                id: "select",
                header: ({ table }) => (
                    <Checkbox
                        checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
                        onCheckedChange={(v) => table.toggleAllPageRowsSelected(!!v)}
                        aria-label="Select all"
                    />
                ),
                cell: ({ row }) => (
                    <Checkbox
                        checked={row.getIsSelected()}
                        onCheckedChange={(v) => row.toggleSelected(!!v)}
                        aria-label="Select row"
                        onClick={(e) => e.stopPropagation()}
                    />
                ),
                size: 50,
                minSize: 50,
                maxSize: 50,
                enableSorting: false,
                enableHiding: false,
                enableResizing: false,
            },
            {
                accessorKey: "id",
                header: ({ column }) => <DataTableColumnHeader column={column} title="ID" />,
                cell: ({ row }) => <span className="font-mono text-sm">{row.original.id}</span>,
            },
            { accessorKey: "channel", header: ({ column }) => <DataTableColumnHeader column={column} title="채널" /> },
            {
                accessorKey: "reportType",
                header: ({ column }) => <DataTableColumnHeader column={column} title="리포트 타입" />,
            },
            {
                accessorKey: "checkType",
                header: ({ column }) => <DataTableColumnHeader column={column} title="체크 타입" />,
            },
            {
                accessorKey: "kwargsByCheckType",
                header: ({ column }) => <DataTableColumnHeader column={column} title="체크 타입 별 인자" />,
                cell: ({ row }) => (
                    <pre className="max-w-[640px] whitespace-pre-wrap break-words text-xs">
                        {JSON.stringify(row.original.kwargsByCheckType)}
                    </pre>
                ),
            },
        ],
        []
    );
}
